import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { save, load } from "redux-localstorage-simple";
import { Provider } from "react-redux";
import { setAdvanceCurrency } from "./redux/actions/currencyActions";
import rootReducer from "./redux/reducers/rootReducer";
import App from "./App";
import "./assets/scss/style.scss";
import * as serviceWorker from "./serviceWorker";
import axios from "axios";
import CacheBuster from "./helpers/cacheBuster";
import { configureStore } from "@reduxjs/toolkit";
import { aetherApi } from "./redux/api/aetherApi";

window.okStatus = 200;

export const store = configureStore({
    reducer: rootReducer,
    preloadedState: load(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({immutableCheck: false})
      .concat(thunk, save({ ignoreStates: ["featureProductData", "blogData", "shopData", "aetherApi"] }))
      .concat(aetherApi.middleware)
});

if (process.env.NODE_ENV) {
  if (process.env.NODE_ENV === 'development') {
    //window.configEnv.WEBSTORESERVER = "https://nehal.aether-stores.io/public/"
    window.configEnv.WEBSTORESERVER = 'http://localhost:3333'
  }
}

const overrideUrl = localStorage.getItem('overrideApiUrl');
const overrideStore = localStorage.getItem('overrideStore');
axios.defaults.baseURL = overrideUrl ? overrideUrl : window.configEnv.WEBSTORESERVER;
axios.defaults.headers['x-store'] = overrideStore ? overrideStore : '';
// fetch products from json file
//store.dispatch(fetchProducts(products));

if (localStorage.storeDetails) {
  store.dispatch({
    type: "STORE_DETAILS",
    payload: JSON.parse(localStorage.storeDetails)
  });
}
if (localStorage.advanceApiurl) {
  window.advanceApiurl = localStorage.advanceApiurl;
}

store.dispatch(setAdvanceCurrency());

ReactDOM.render(
    <Provider store={store}>
      <CacheBuster />
      <App />
    </Provider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
